import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { pluck} from 'rxjs/operators';


interface wikipediaResponse{
  query:{
    search:{
      title:string,
      snippet: string,
      pageid:number,
      wordcount:number,
    }[]
  }
}

@Injectable({
  providedIn: 'root'
})

export class WikipediaService {

  constructor(private http:HttpClient) { }

  search(value:string){
    return this.http.get<wikipediaResponse>("https://en.wikipedia.org/w/api.php",{
      params:{
        action:'query',
        format:'json',
        list:'search',
        utf8:'1',
        srsearch:value,
        origin:'*'

      }
    }).pipe(
      pluck('query', 'search')
    );
  }
}
